import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var LayersSvg = function LayersSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m12 2.249 10 5.396-10 5.396L2 7.645zM4.93 7.645 12 11.46l7.07-3.815L12 3.83z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m2.176 12.438.68-1.213L12 16.07l9.143-4.844.681 1.213L12 17.643z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.857 15.83 12 20.676l9.143-4.844.681 1.213L12 22.249l-9.824-5.205z"
  }));
};
export var Layers = function Layers(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: LayersSvg
  }));
};